/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q8Inputs */

const en_fc_home_faq_q8 = /** @type {(inputs: Fc_Home_Faq_Q8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where is the FilmCraft GitHub repository?`)
};

/**
* | output |
* | --- |
* | "Where is the FilmCraft GitHub repository?" |
*
* @param {Fc_Home_Faq_Q8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q8 = /** @type {((inputs?: Fc_Home_Faq_Q8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q8(inputs)
});
export { fc_home_faq_q8 as "fc.home.faq.q8" }